import "/home/thunder/Proyectos/instant-loans/sentry.client.config.js";
import { init } from 'astro/virtual-modules/prefetch.js';init()